import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, ElementRef, ViewChild, ViewContainerRef } from '@angular/core';
import { WDSSelectionMode, WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION, WIZ_BOOLEAN, WizBooleanUtils } from '@wizeoo/akm-core-lib';
import { PopUpManager, WizAgGrid, WizComponentManager, WizHgroup, WizIcon, WizPopUp, WizRoot, WizEventManager, WizTranslationManager, CellCheckedEvent } from '@wizeoo/akm-component-lib';
import { CellClickedEvent, CellKeyPressEvent, CellPosition, FullWidthCellKeyPressEvent } from 'ag-grid-community';
import { ColDef, ColGroupDef, Column, GridOptions } from 'ag-grid-community';
import { COMPUTE_MODE, ComputeResult, EM_ACTION, FeiKeyDef, FIELD_KIND, WizConstants } from '@wizeoo/akm-compute-lib';
import { isEqual } from 'lodash-es';
import { WidgetConfigurationObj, WidgetConfigurationItemObj, DataPack } from '@wizeoo/akm-message-lib';
import { ClipboardService } from 'ngx-clipboard';


import { ALK_EVENT_TYPE, WIDGET_ACTION_ORIGIN, WIDGET_GLOBAL_KIND, WIDGET_KIND, WIDGET_STATE } from '../../../model/enums';
import { ViewData } from '../../../model/view.data';
import { FreedataArgsVO } from '../../../vo/core/freedataargs.vo';
import { FreedataValueVO } from  '../../../vo/core/freedatavalue.vo';
import { PopUtils } from '../../../framework/components/pop/pop-utils';
import { IWidget, IFreedataWidget, IWidgetFilter, PivotCellEditPopData } from '../../../manager/widgets/i-widget';
import { FreeDataVO } from '../../../vo/core/freedata.vo';
import { FastSelectData, PivotFocusedCell, WidgetEngine } from './../../../manager/widgets/widget.engine';
import { AlkEvent } from '../../../framework/events/alk.event';
import { WizColDef } from '../../../manager/workingdata/fei.engine';
import { ExcelSheetVo } from '../../../manager/export/excel-sheet.vo';
import { ConnectVO } from '../../../vo/core/connect.vo';
import { MediaReference } from '../../../command/core/attachment/attachment.service';
import { AttachmentService } from '../../../command/core/attachment/attachment.service';
import { FreedataWidgetBasic } from '../base/freedata-widget-basic';
import { PivotFilterExtendedRenderer } from '../pivot/renderers/filters/pivot-filter-extended.renderer';
import { FreedataSettingsPop } from './pops/freedata-settings.pop';
import { DeleteFreedataValueParams, FreedataGridDeletePop } from './pops/freedata-grid-delete.pop';
import { FreedataTileFilterPop } from '../tiles/settings/freedata-tile-filter.pop';
import { zoomPopParams } from './renderers/zoom.pop';

import { PivotCellEditor } from '../pivot/renderers/cells/pivot-cell.editor';
import { PivotHeaderGroupRenderer } from '../pivot/renderers/header/pivot-headergroup.renderer';
import { FeiVO } from '../../../vo/workingdata/fei.vo';
import { CompositeSourcePack, UpdateRevert } from '../../../command/core/sync/sync.service';



@Component({
  selector: 'freedatagrid-widget',
  templateUrl: './freedatagrid.widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
/** affichage des données en mode liste */
export class FreedataGridWidget extends FreedataWidgetBasic implements IFreedataWidget {
  /* ##############################################################################
                  composants spécifiques
  ############################################################################## */

  constructor(elementRef: ElementRef, private _cdRef: ChangeDetectorRef, private _clipboardService: ClipboardService) {
    super(elementRef);
    this.widgetKind = WIDGET_KIND.FD_GRID;
    this.widgetGlobalKind = WIDGET_GLOBAL_KIND.FREEDATA;
    this.settingsPopClassFactory = FreedataSettingsPop;
  }

  /** accesseur self pour l'alimentation du compo AgGrid */
  get widget(): IWidget {
    return this;
  }

  @ViewChild('agGrid') agGrid: WizAgGrid<FreedataValueVO>; // grid
  @ViewChild('hgDetailZone', { read: WizHgroup, static: true }) hgDetailZone: WizHgroup; // zone de filtre, pour écouteur sur setFilter
  @ViewChild('btnConf') btnConf: WizIcon; // btn settings
  @ViewChild('containerFilter', { read: ViewContainerRef, static: true }) containerFilter: ViewContainerRef; // zone d'ajout des champs de filtre
  @ViewChild('moreFilterIcon') moreFilterIcon: WizIcon;
 
  /* ##############################################################################
                  paramètres spécifiques
  ############################################################################## */

  public fakeFei: FeiVO = null; // fei Fake pour gestion des contrôles de cohérence

  columns: (ColDef | ColGroupDef)[]; // Colonnes du grid

  /** composant utilisés par le grid */
  public gridFrameworkComponents = { pivotCellEditor: PivotCellEditor, pivotHeaderGroupRenderer: PivotHeaderGroupRenderer };


  gridOptions: GridOptions = {
    onCellFocused: (params) => this.onCellFocus(params as CellPosition), // sur prise de focus
    onColumnResized: (params) => this.onColumnResize(params),
    onSortChanged: (params) => this.onSortChanged(params),
    suppressRowClickSelection: true,
    onCellDoubleClicked: (params) => this.onCellDouble(params), // 2x clic pour copy content
    getRowNodeId: (params) => params?.code,
    onCellKeyPress:(params) => this.trapCrtlZ(params),
    // onCellMouseDown: (e) => this.onCellMouseDown(e),
    // onCellMouseUp: () => this.onCellMouseUp(),
    // onCellMouseLeave: () => this.onCellMouseLeave()
  };
  
  // taille par défaut des lignes 
  public get rowHeight(): number {
    let res: number = ViewData.defaultRowHeight;
    if(this.context?.rowHeight) {
      res = this.context.rowHeight;
    }
    return res;
  }

  // taille par défaut des entêtes (pour override si ajout des saisies en masse dans les headers)
  public get headerHeight(): number {
    let res: number = ViewData.defaultHeaderHeight;
    if(this.context?.headerHeight) {
      res = this.context.headerHeight;
    }
    return res;
  }

  public get groupHeaderHeight(): number {
    let res: number = 35;
    return res;
  }


  /** afficher les checkboxes de sélection */
  get showRowSelection(): WDSSelectionMode {
    if(!this._context?.shs) { // pas de sélection
      return 'none';
    } else {
      if(!!this._context?.shsu) { // sélection unique
        return 'wiz-single';
      } else {
        return 'multiple';
      }
    }
  }

  get showRowDeletion(): boolean {
    return this._context?.shd ; // TODO droit sur FD && PermissionManager.instance.feiCanDelete(this.fei);
  }
  
 /** collection de champs de filtre */
 public filterComponents: ComponentRef<any>[];

  /* ##############################################################################
                    alimentation des données FEI / construction du grid
  ############################################################################### */

  /**
   * actions jouées sur le drawContent, le alterContent, ou en cas de modifs de filtre, de sélection
   * @override
   * @param origin WIDGET_ACTION_ORIGIN pour cibler qui demande
   * @param data l'objet éventuellement porté
   */
  public drawOrRefresh(origin: WIDGET_ACTION_ORIGIN, data?: any): void {
    let mustBuildFilters: boolean = false; // on doit construire les filtres
    let mustBuildRows: boolean = false; // on doit construire les lignes
    let mustFilter: boolean = false; // on doit appliquer les filtres
    let mustSelect: boolean = false; // on doit jouer la sélection de lignes
    let mustBuildColumns: boolean = false; // on doit construire les colonnes
    let mustRefresh: boolean = false; // simple refresh sur recalcul

    // console.log('FD GRID drawOrRefresh', origin, this.state, data);

    // première création
    if(origin === WIDGET_ACTION_ORIGIN.INIT) {
      // alimentation du level pour filtre rapide des slaves
      this.freedataCode = this.context.fdk.split(ViewData.CONTEXT_SEPARATOR)[0];
      this.level = Number(this.context.fdk.split(ViewData.CONTEXT_SEPARATOR)[1]);
      
      // construction de la FeiKeyDef unique du widget
      this.buildFeiKeyDef(this.vision, this.context);

      // FEI nécessaire pour les calculs inter-champs
      if(this.fei) { // step lié, on prend son FEI
        this.fakeFei = this.model.dataEngine.generateFakeFEI(this.fei) as FeiVO;  
      } else { // sinon, le 1er dispo
        let tmpFEI: FeiVO  = this.model.dataEngine.getFei(COMPUTE_MODE.LOCAL, 1, ViewData.DEFAULT_SCENARIO) as FeiVO;
        if(!tmpFEI) {
          tmpFEI = this.model.dataEngine.generateFei(this.model.currentVision, 
            this.model.currentVision.visionSteps[1], 
            ViewData.DEFAULT_SCENARIO, this.context, true);
        }
        if(!!tmpFEI) {
          this.model.measureEngine.buildFeiMatrix(tmpFEI);
          this.fakeFei = this.model.dataEngine.generateFakeFEI(tmpFEI) as FeiVO;  
        }

        
      }



    }
    
    if(origin === WIDGET_ACTION_ORIGIN.READY) { // je me suis dit tout seul que j'étais prêt   
      
      mustBuildFilters = true;
      mustBuildRows = true;
      mustSelect = true;
      mustBuildColumns = true;
    }

    // TODO sur configuration, capter les delta filter, colonnes, fields...

    // TODO TODO détecter une modification structurelle en cas 
    // contextDamaged
    // origine: changement de config
    // et mode pivot, sinon les lignes sont toujours OK
    if(origin === WIDGET_ACTION_ORIGIN.CONFIGURE) {   
      mustBuildFilters = true;
      mustFilter = true;
      mustBuildColumns = true;
    } 
    
    // modification du filtre... on filtre, et on corrige éventuellement la sélection
    // en cas de champ utilisé en colonne, on reconstruit le grid
    if(origin === WIDGET_ACTION_ORIGIN.FILTERING || origin === WIDGET_ACTION_ORIGIN.GLOBAL_FILTERING) {
      // console.log('globalFiltering on FDGrid')
      mustFilter = true;
    }

    // modification du pool de sélection sur un master
    if(origin === WIDGET_ACTION_ORIGIN.OUTER_SELECT) {
      // console.log('outer select', this.widgetKind, this.fei.uniqueName, this.state);
      mustBuildRows = true;
      mustSelect = true;
      mustFilter = true;
      mustRefresh = true;
    }

    if(origin === WIDGET_ACTION_ORIGIN.RECOMPUTE) { // TODO TODO Faire moins bourrin
      // mustBuildRows = true;
      // mustSelect = true;
      // mustBuildFilters = true;
      // mustFilter = true;
      // synchroniser la DS avec les élements modifiés (pour sync)
      // console.log('recompute FD', data);
      mustBuildRows = this.syncDS(data);  
      mustRefresh = true; // mustBuildRows; // nécessaire pour le retour sur edit par crayon
    }

    if(mustBuildFilters) {
      this.buildFilters();
    }

    if(mustBuildRows) {
      this.buildLines(); // délégué au WidgetBasic
    }

    if(mustSelect) {
      this.feedSelectionFromContext(this._context); // alimentation de la sélection et passage à WIDGET_STATE = SELECTION_COMPLETE
    }

    if(mustFilter) {
      this.model.widgetEngine.refreshFreedataFilter(data); // reconstruction du filtre (symboliques)
      this.fdvDS.refresh(); // on applique le filtre

      // potentiellement, on déselectionne
      if(this.fdvDS.selectedItems?.length > 0) {
        // contrôle de la sélection. On déselection les éléments masqués
        let realSelected: FreedataValueVO[] = [];
        this.fdvDS.selectedItems.forEach((line: FreedataValueVO) => {
          if(!!this.fdvDS.getItemByKey(line.code)) {
            realSelected.push(line);
          }
        });

        if(realSelected.length === this.fdvDS.selectedItems.length) { // tout est OK

        } else {
          this.fdvDS.select(realSelected);
          this.onSelectionChanged(); // persistence du contexte de sélection
          this.updateComponentSelection(); // informer les esclaves
        }
      }
    }

    if(mustBuildColumns) {
      this.buildColumns(); // pour override dans les toolPivots
      // this.changeHeaderColor();
      if(!!this.context.gps) { // état existant sur les colonnes
        this.agGrid.columnApi.setColumnGroupState(this.context.gps); 
      }
      // construction des filtres physiques
      this.buildFilterDrops();
    }

    if(mustRefresh) {
      // console.log('mustRefresh');
      this.agGrid.api.refreshCells(); // refresh des values modifiées
    }

    // console.log('origin', origin);
    // console.log('mustBuildRows', mustBuildRows);
    // console.log('mustBuildColumns', mustBuildColumns);
    // console.log('mustFilter', mustFilter);
    // console.log('mustRefresh', mustRefresh);

    // en cas de recréation des lignes (ajout sur override de scenar), repositionnement correct sur retour de commit
    if(this.model.widgetEngine.imLastFocus(this)) {
      // console.log('imLastFocus', this.model.widgetEngine.lastFocusedCell);
      let pfc: PivotFocusedCell = this.model.widgetEngine.lastFocusedCell;
      if(!!pfc) {  
        // console.log('pcf', pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
        if(pfc.focusedCell?.rowIndex !== null) {
          if(!this.activeFocus) {
            this.agGrid.api.ensureIndexVisible(pfc.focusedCell.rowIndex);
            this.agGrid.api.setFocusedCell(pfc.focusedCell.rowIndex, pfc.focusedCell.column); 
          }
         
        }
        // console.log('pcf exist', pfc.focusedCell, this.activeFocus);
        this.model.widgetEngine.lastFocusedCell = null; // et on oublie
      }
    }

    setTimeout(() => { // application du sort du grid (sur sortKeys) Timeout, sinon l'aggrid n'a pas encore construit ses colonnes
      // contrôle du sort
      // this.forcePMDSort();
      // contrôle du sort
      if(origin !== WIDGET_ACTION_ORIGIN.INIT &&
        origin !== WIDGET_ACTION_ORIGIN.RECOMPUTE
      ) 
      {
        // console.log('forcePMDSort', origin);
        this.forcePMDSort();
      }

      //LMAM 
      // this.agGrid.api.redrawRows(); // test refresh style 1er instance
      //LMAM 
      // this._cdRef.markForCheck();
    }, 0);
  }

  /**
   * construction des colonnes
   */
  public buildColumns(): void {
    this.columns = this.model.feiEngine.buildFDGridColumns(this, this.context, true);
  }

  /**
   * construction 'initiale' des objets graphiques du widget :
   * - sur init véritable
   * - sur modification de la datasource
   * - sur modification de scenario (modifie la DS)
   */
  public drawContent(): void {
    
    let master: IWidget = this.model.widgetEngine.checkFirstMaster(this); // je cherche un master. S'il y en a un, READY n'est pas suffisant
    // si j'ai un master et qu'il n'est pas prêt, on ne fait rien
    if (!!master && master.state !== WIDGET_STATE.SELECTION_COMPLETE) { // j'ai un master, mais il n'est pas prêt
      // console.log('checkFeiState master not ready', this.widgetKind, this.fei.uniqueName);
      return;
    }

    if(this.state >= WIDGET_STATE.READY) { // déjà construit, plus rien a faire
      return;
    }

    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.INIT); // actions communes draw / alter
    super.drawContent(); // pas au début, c'est lui qui dispatch les events
  }

  /**
   * reconstruction des objets graphiques du widget sur changement de structure : 
   * - modification des filtres qui impactent les colonnes
   * - changement de champs en ligne / colonnes / data
   * - changement de filtre
   * - changement de sélection
   * @param origin 
   */
  public alterContent(origin: WIDGET_ACTION_ORIGIN, data?: any): void {
    this.drawOrRefresh(origin, data);
    super.alterContent(origin, data);
  }

  /* ##############################################################################
                  cycle de vie
     ############################################################################## */

  ngAfterViewInit() {
    super.ngAfterViewInit();
    // modification du pool de sélection de la DS
    WizEventManager.addListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.innerSelectionChange);

  }

  ngOnDestroy() {
    super.ngOnDestroy();
    WizEventManager.removeListener(this, this.agGrid, WIZ_EVENT_TYPE.SELECTION_CHANGED);
  }

  /* ##############################################################################
                    gestion des filtres (composants drop)
     ############################################################################## */

  /**
   * interception de modification de filtre pour déclencher un refresh
   */
  protected innerUpdateFilter(e: AlkEvent): void {
    super.innerUpdateFilter(e);
    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING, e.data);
  }

  /** suppression des combos de filtres (avant changement de step, ou sur retour de pop) */
  private clearFilterDrops(): void {
    this.containerFilter.clear(); // vider le container des favoris
    this.filterComponents = []; // on rince la référence aux filtres
    this._needMore = false;
  }

 /** construction des dropdowns de filtre selon le contexte */
  protected buildFilterDrops() {
    this.clearFilterDrops(); // on rince tout
    
    let maxSize: number = this.hgDetailZone?.elementRef?.nativeElement?.offsetWidth;
    let currentSize: number = 0;

    // console.log('size', this.hgDetailZone.elementRef.nativeElement.offsetWidth);

    // construire unique le rendu, pas besoin d'alimenter les collections tant que la drop n'est pas ouverte
    if(this.filters) {
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
        let compoSize: number = WidgetEngine.getFilterSize(filter);
        if(currentSize + compoSize + 2 <= maxSize - WidgetEngine.ICONS_FILTER_SIZE) {
          const meCompo: ComponentRef<any> = WizComponentManager.instance.addChildTo(
            PivotFilterExtendedRenderer,
            this.containerFilter,
            { instanceProperties: { data: filter } }
          );
          this.filterComponents.push(meCompo);
          currentSize+= compoSize + 7;
        } else {
          this._needMore = true;
        }
        

      });
    }
    this._cdRef.markForCheck();
  }

  private _needMore: boolean = false;
  public get needMore(): boolean {
    return this._needMore;
  }

  public get hasFilter(): boolean {
    return this.filters?.size > 0;
  }

  public get hasActiveFilter(): boolean {
    let res: boolean = false;
    if(this.filters) {
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
       if(filter.active) {
        if(!!this.templatingMode || !filter.wcio.filtHide)
        res = true;
       }  
      });
    }
    return res;
  }

  /* ##############################################################################
          accesseurs pour les rendus
     ############################################################################## */

  /**
   * méthode d'accès aux Keys
   * retourne la valeur de la cellule (pour les sorts, par exemple)
   * @param params la conf d'une cellule de grid. .data contient un FreedataValueVO
   */
  public keyValueAccessor(params: any): any {
    let fdv: FreedataValueVO = params.data;

    // prise de la valeur
    const field : string = params.colDef.fdvfield.split(WizConstants.FD_PARTS_SEPARATOR)[0];
    let result: any = fdv.argsObjVO[field];

    let conf: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
    let realDatakind: string = params.colDef.datakind;
    
    // console.log('kva', params.colDef.datakind, params.colDef.fdvfield, result);
    // gestion des sous-objets
    let realFDV: FreedataValueVO = null;

    if (conf?.dataType === FIELD_KIND.OBJECT) { // sous-FDV
        
      let parts: string[];
      try {
        parts = result.split(WizConstants.CONTEXT_SEPARATOR);
      } catch(e: any) {
        // console.log('bad result', result, e);
        parts = [];
        parts.push['oups error'];
      }
      
      let realFD: FreeDataVO = this.model.freedataEngine.getFreeData(parts[0]);
      realFDV = realFD?.getFreeDataValue(parts[1]);
      if(realFDV) {
        const subField: string = params.colDef.fdvfield.split(WizConstants.FD_PARTS_SEPARATOR)[1];
        conf = this.model.freedataEngine.getArgFromFD(realFD.code, subField);
        result = realFDV?.argsObjVO[subField];
      } else {
        result = '';
      }
    }


    // neutralisation du undefined sur les checkboxes : passage à false en mode simple
    if (realDatakind === FIELD_KIND.BOOLEAN) {
      if (!result || result === WIZ_BOOLEAN.UNKNOWN) {
        result = WIZ_BOOLEAN.FALSE;
      }
    } else if (realDatakind === FIELD_KIND.NUMBER) {
      result = Number(result) || null;
    } else if (realDatakind === FIELD_KIND.BINARY) {
      // console.log('binary', params.colDef, result);  
      // let fdvfield: string = params.colDef.fdvfield;
      // try {
      //   if(fdvfield.indexOf(WizConstants.FD_PARTS_SEPARATOR) > 0) { // un sous-champ média : "COUNTRY@icon"
          
      //     if(!!result) {
      //       console.log('binary sur part', params.colDef, result, fdvfield);
      //       // dans cas, la value, c'est FD#FDV
          
      //       // collecte du champ désiré sur le FDV (partie [1])
      //       let parts: string[] = fdvfield.split(WizConstants.FD_PARTS_SEPARATOR);           
      //       let valParts: string[] = result.split(WizConstants.CONTEXT_SEPARATOR);
      //       let realFDV: FreedataValueVO = this.model.freedataEngine.getFreedataValue(valParts[0], valParts[1]);
      //       if(realFDV) {
      //         result = this.model.freedataEngine.getFDValue(realFDV, parts[1]);
      //         console.log('binary sur part got you', result);
      //       }
      //     }
      //   }

      // } catch(e: any) {
      //   console.log('binary oups', params.colDef, result, e);  
      // }
    } 
    // else if (conf?.dataType === FIELD_KIND.OBJECT) { // sous-FDV)  
      
    //   console.log('conf.dataType pourquoi ??', realDatakind, params.colDef.fdvfield, result);
    //   // on garde la valeur, c'est le formateur qui va gérer

    // } 
    else if (conf?.dataType === FIELD_KIND.WORKFLOW) { // sous-FDV)
      // on garde la valeur, c'est le formateur qui va gérer
    } 

    // console.log('keyValueAccessor', conf.code, result);

    return result;
  }

  /**
   * méthode d'accès aux Keys / filterKeys du pivot
   * retourne la valeur visible (label)
   * @param params la conf d'une cellule de grid. .data contient un FreedataValueVO
   */
   public keyFormatterAccessor(params: any): any {
    let result: any = params.value;
    
    const field : string = params.colDef.fdvfield.split(WizConstants.FD_PARTS_SEPARATOR)[0];
    let fdv: FreedataValueVO = params.data;
    let conf: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
    
    let realDatakind: string = params.colDef.datakind;

    if(result !== null && result !== undefined) {
      if (conf?.dataType === FIELD_KIND.ACTION) { // rendu action, on passe la fonction connect dans value
        const cnx: ConnectVO = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(conf.action); 
        result = cnx;
      }
  
      else if (!!conf && conf.dataType === FIELD_KIND.FORMULA) { // formule, on calcule 
        let cr: ComputeResult = this.model.freedataFormulaCoreEngine.computeFreedataExp(fdv, conf.valor, this.fei);
        // console.log('keyval cr',conf.code, cr);
        result = cr?.valor ;
        this.model.freedataEngine.feedFreedataValueField(fdv, params.colDef.fdvfield, result);
        // fdv.addArg(params.colDef.fdvfield, result); // ajout sur le fdv comme valeur de args, pour filtres
      }

      else if (conf?.dataType === FIELD_KIND.WORKFLOW) { // rendu action, on passe la fonction connect dans value
        result = this.model.workflowEngine.valueFormatterFD(params);
        //console.log('got message', result, conf.settings);
      }

      // interception LIST 
      else if(conf?.dataType === FIELD_KIND.LIST) { 
        result = this.patchListFormatter(params);
        // console.log('FDGrid list', result);
      } 
      // interception Seuils 
      else if(conf?.dataType === FIELD_KIND.THRESHOLD) { 
        result = this.patchThresholdFormatter(params);
        // console.log('FDGrid list', result);
      } 

      if (!!conf) { // application du format
        let realFormat: string = conf.format;
        if(!!params.colDef?.wcio?.fmt) {
          realFormat = params.colDef.wcio.fmt;
        }
        result = this.model.formatEngine.applyFormat(result, realDatakind, realFormat, null);
      }
    } else { // pas de résult
      result = '';
      if (!!conf && conf.dataType === FIELD_KIND.FORMULA && conf.valorTrigger?.indexOf(ViewData.TRIGGER_ALWAYS) > -1) { // formule, on calcule 
        let cr: ComputeResult = this.model.freedataFormulaCoreEngine.computeFreedataExp(fdv, conf.valor, this.fei);
        
        // console.log('keyval no val',conf.code, cr);
        result = cr?.valor ;
        this.model.freedataEngine.feedFreedataValueField(fdv, params.colDef.fdvfield, result);
        
        let realFormat: string = conf.format;
        if(!!params.colDef?.wcio?.fmt) {
          realFormat = params.colDef.wcio.fmt;
        }
        result = this.model.formatEngine.applyFormat(result, conf.dataType, realFormat, null);
      }   
    }
    
    // console.log('keyFormatterAccessor', conf.code, result);
    return result;
  }

  /* ##############################################################################
                mémorisation du tri & des tailles de colonnes
     ############################################################################## */

  /** mémorisation de groupes de colonnes */
  onColumnGroupEvent(e: Event): void {
    const context: WidgetConfigurationObj = this._context;
    context.gps = this.agGrid.columnApi.getColumnGroupState();
    this.updateContext(context);
  }


  /**
     * interception du resize des colonnes pour mémorisation dans le contexte
     * @param params any
     */
  public onColumnResize(params: any): void {
    if (params.source === 'uiColumnDragged' && params.finished) {
      // console.log('col resize', params);
      const coll: Column[] = params.columns;
      const context: WidgetConfigurationObj = this._context;

      const candidates: WidgetConfigurationItemObj[] = this.context.r.concat(this.context.d);
      coll.forEach((c: any) => {
        const candidate: WidgetConfigurationItemObj = candidates.filter((item) => item?.ord === c.colDef.wcio.ord)[0]; // un seul
        candidate.csiz = c.actualWidth;
        if (!!candidate.cmsiz && candidate.cmsiz > candidate.csiz) {
          candidate.cmsiz = candidate.csiz;
        }
      });

      this.updateContext(context, true);
    }
  }

  /** mémorisation du sort */
  public onSortChanged(params: any): void {
    const context: WidgetConfigurationObj = this._context;
    const colParams = this.agGrid.columnApi.getColumnState();
    const cleans: any[] = []; // on ne prend que le sort
    colParams.forEach((param: any) => {
      let sortObj: any = { colId: param.colId, sortIndex: 0, sort: param.sort };   
      if(!!param.sort && !!param.sortIndex) {
        // console.log('param.sort', param);
        sortObj.sortIndex = param.sortIndex;
      } 
      cleans.push(sortObj);
    });

    let hasUpdate: boolean = !isEqual(context.sort, cleans);
    if(hasUpdate) { //maj si modifs uniquement
      context.sort = cleans;
      this.updateContext(context, true); 
    }
    // context.sort = cleans;
    // this.updateContext(context, hasUpdate); // forcer la maj si modifs uniquement
  }

  /* ##############################################################################
              suppression
     ############################################################################## */

  /** Handler sur demande de suppression d'une ligne */
  onItemDeleted(event: CellClickedEvent) {
    const fdvvo: FreedataValueVO = event.data as FreedataValueVO;
    let popFactory: any = FreedataGridDeletePop;
    let width: string = '400px';
    let height: string = '350px';

    if (this._context.eda === false) { // widget en lecture seule
      return;
    }

    let params: DeleteFreedataValueParams = {fdv: fdvvo, widget: this, callback: this.doDelete.bind(this)};


    const deletePop: WizPopUp = new WizPopUp(popFactory, false, false, null, width, height, params);
    const pos: DOMRect = (event.event.target as Element).getBoundingClientRect();
    const bestXY: [number, number] = PopUtils.setPopCoord(pos, deletePop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    deletePop.customPosition = targetPosition;

    if (PopUpManager.exist(deletePop)) {
      // suppression de l'instance existante
      deletePop.hide();
    }
    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    deletePop.show();
  }


    /* ##############################################################################
          tools
  ############################################################################## */

  /** 
   * copie vers le clipboard sur 2x clic 
   * et sélection rapide
   */
  private onCellDouble(params: any): void {

    // this._clipboardService.copy(params.value);

    if(!!this._context?.shs) {
      this.fdvDS.select([params.data]);
      this.onSelectionChanged(); // persistence du contexte de sélection
      this.updateComponentSelection(); // informer les esclaves
    }
    let fsd: FastSelectData = {fei: this.fei, kind: this.widgetGlobalKind, data: params.data};
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PIVOT_DOUBLE, fsd));
  }

  /** demande d'export depuis le bouton */
  // public exportDatas(): void {
  //   this.model.excelExportEngine.exportAsExcel('allkeyme', this);
  // }

  /** demande d'export depuis le bouton */
  public exportDatas(kind?: string): void {
    if(!kind || kind === 'excel') {
      this.model.excelExportEngine.exportAsExcel('allkeyme', this);
    } else {
      this.model.excelExportEngine.exportAsPdf('allkeyme', this, this.elementRef, null, '1000px');
    }
  }


  /**
   * drop d'un fichier excel (excelExportEngine)
   * @param sheet 
   */
   public fileDrop(sheet: ExcelSheetVo): void {
    this.model.excelExportEngine.excelDropFreedata(sheet, this);
  } 


  /** 
   * Handler sur le clic d'une colonne de type action (connect)
   * @param param0 
   * @returns 
   */
  onAction(params: CellClickedEvent) {
    
    if (this._context.eda === false) { // widget en lecture seule
      return;
    } 
    const line: FreedataValueVO = params.data; // ligne source
    const cnx: ConnectVO = params.value;
    this.model.connectEngine.doArgActionExt(cnx?.code, this, [line]);
  }

  /** passage des éléments de contexte au wizTile pour transmission aux renderers */
  public get countLabel(): string {
    let mess: string = ''; 
    if(this.fdvDS) {
      mess = this.fdvDS.getWorkedSource().length + ' / ' + this.fdvDS.getSource().length;
      mess += ' ' + WizTranslationManager.getInstance().translateKey('$.widget.elements.$');
    }

    return mess;
  }

  /**
   * clic sur le crayon d'édition
   * @param params tout le bazard { colDef, data, column, event, value }
   */
  onCellFile(params: any) {

    let datakind: string = (params.colDef as WizColDef)?.datakind;
    if(datakind === FIELD_KIND.FILE) {
      if(params.value) {
        try {
          let mediaReference: MediaReference = JSON.parse(params.value);
          if(!!mediaReference) {
            AttachmentService.getInstance().filedownloadForWidget(mediaReference);
          }
        } catch(e: any) {

        }      
      }
      return;
    }
    if(datakind === FIELD_KIND.WORKFLOW) { // pièce jointe sur workflow
      //console.log('bob WORKFLOW', params.value);
      if(params.value) {
        try {
          let rawobj = this.model.workflowEngine.valueFormatterFD(params);
          let smallMess: any = JSON.parse(rawobj) 
          let mediaReference: MediaReference = smallMess?.media;
          if(!!mediaReference) {
            AttachmentService.getInstance().filedownloadForWidget(mediaReference);
          }
        } catch(e: any) {

        }      
      }
      // console.log('cellEdit on file type');
      return; // ici on essaye d'éditer... C'est pas autorisé
    } 
  }


  /** clic sur un média, zoom */
  onImage(event: CellClickedEvent) {
    let colDef: WizColDef = event.colDef;
    let data: FreedataValueVO = event.data;
    if(colDef.datakind === FIELD_KIND.BINARY || colDef.datakind === FIELD_KIND.BINARY_MULTI) {
      let realValue = event.value; // this.keyFormatterAccessor(event); // le blobID
      if(realValue) {
        // this.seeImage(AttachmentService.getInstance().downloadAttachmentForWidget(realValue));
        this.seeImage(realValue);
      }
    }

  }

  private zoomPop: WizPopUp; // la popUp de zoom sur les images
  /**
   * zoom sur une image
   */
  public seeImage(blobid: string): void {
      let params: zoomPopParams = {
        zoomPop: this.zoomPop,
        blobid: blobid,
        // arg: this.data.arg,
        //fdvDS: this.data.ds
      }
    
    PopUtils.showZoomPop(params);
  }

 
  public clearAllFilter(): void {

    // ne pas rincer les filtres masqués
    if(this.filters) { // on rince les IWidgetFilter
      [...this.filters.values()].forEach((filter: IWidgetFilter) => {
        if(!!this.templatingMode || !filter.wcio.filtHide) {
          filter.values = null;
          filter.regex = null;
          filter.active = false;
        }
        
      });
    }
    
    // on rince le contexte
    this.context.f.forEach(wcio => {
      if(!!this.templatingMode || !wcio.filtHide) {
        wcio.sel = null;
      wcio.filtExp = null;
      }
    });

    // on rince les instances
    this.filterComponents.forEach(pfer => {
      if(!!this.templatingMode || !pfer.instance.context.filtHide) {
        pfer.instance.clearFilter(false); // clear sans dispatch
      }
      
    });

    // persistence uniquement hors du template, sinon, c'est délégué
    if (!this.templatingMode) { 
        this._saveContext();
    } else { // mise à jour du template, pas du contexte
        this.settings = this.context;
        WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_SET_SETTINGS, this));
    }     

    this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING);// et application du filtre
  }
  
  /**
   * détection du resize pour redessiner les filtres
   * @override
   * @param width 
   * @param height 
   */
  public onResize(width, height): void {
    if(this._previousSize && this._previousSize.width !== width) {
      this.buildFilterDrops();
    }
    super.onResize(width, height);
  }

  /**
   * pop de liste des filtres
   */
  public moreFilterPop(): void {

    const pop: WizPopUp = new WizPopUp(
      FreedataTileFilterPop,
      false,
      false,
      WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      FreedataTileFilterPop.width,
      FreedataTileFilterPop.height,
    );

    const pos: DOMRect = this.moreFilterIcon.elementRef.nativeElement.getBoundingClientRect();
    const bestXY: [number, number] = PopUtils.setPopCoord(pos, pop, WIZ_PHYSIC_POSITION.BOTTOM_RIGHT);
    const x: string = bestXY[0] + 'px';
    const y: string = bestXY[1] + 'px';
    const targetPosition: any = { left: x, top: y }; // position physique
    pop.customPosition = targetPosition;
   
    pop.setCallback(this.backFromFilterPop.bind(this));

    pop.datas = [this,this.filters];

    if (PopUpManager.exist(pop)) { // suppression de l'instance existante
      pop.hide();
    }
    pop.show();
  }

  private backFromFilterPop(updates: Map<string, IWidgetFilter>): void {
 
    if(updates?.size > 0) { // on reconstruit les filtres
      
      // les contextes de filtre
      const filterMap: Map<string, WidgetConfigurationItemObj> = new Map(this.context.f.map((item) => [item.cod + item.fdvf, item]));

      [...updates.keys()].forEach(k => {
          let up: IWidgetFilter = updates.get(k);
          let existWcio = filterMap.get(k);
          if (up.active) { // seulement si le filtre est actif
            if(up.fkd?.datakind === FIELD_KIND.LIST) {
              existWcio.sel = up.values?.size > 0 ? [...up.values].join(ViewData.DOUBLEKEY_SEPARATOR) : null;
            } else {
              existWcio.sel = up.values?.size > 0 ? [...up.values].join(ViewData.KEY_SEPARATOR) : null;
            }
            existWcio.filtExp = up.regex;
            
          } else {
            existWcio.sel = null; // null car '' signifie qu'il y a quand même un filtre (=> filtre sur les valeurs vides)
            existWcio.filtExp = null;
          }
      });

      this.buildFilters();
      this.buildFilterDrops();
      
      // persistence uniquement hors du template, sinon, c'est délégué
      if (!this.templatingMode) { 
          this._saveContext();
      } else { // mise à jour du template, pas du contexte
          this.settings = this.context;
          WizEventManager.dispatchEvent(this, new AlkEvent(ALK_EVENT_TYPE.WIDGET_SET_SETTINGS, this));
      }  

      // et on filtre
      this.drawOrRefresh(WIDGET_ACTION_ORIGIN.FILTERING);// et application du filtre
    }
  }


  /**
   * patch pour le rendu des lists
   * @override
   * @param params 
   * @returns 
   */
  public patchListFormatter(params: any): string {    
    
    let result: string;
    const fdv: FreedataValueVO = params.data; // ligne source
    const colDef: WizColDef = params.colDef; // définition de la colonne
    const code: string = params.colDef.field; // champ mesure cible code#mode|fonction d'aggrégat
    // identifiant unique de la colonne
    const colId: number = params.column.instanceId;
    // valeur calculée par keyValueAccessor
    const val: string = params.value;
    // le format
    const format: string = params.colDef.dataformat;

    // console.log('arg', params);
    const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, colDef.fdvfield);

    // patch gestion de l'extraction en mode brute
    if(format) {
      try {
        let formatKind: string = format.split(WizConstants.KEY_SEPARATOR)[1];
        if(formatKind === WizConstants.RAW) {
          result = params.value;
          // console.log('list format', format, result);
          return result;
        }
      } catch(e: any) {

      }    
    }


    result = this.model.listFieldEngine.generateRendererForFDV(this.fakeFei, fdv, arg, val);
    return result;
  }

  /**
   * patch pour le rendu des seuils
   * @override
   * @param params 
   * @returns 
   */
  public patchThresholdFormatter(params: any): string {    
    
    let result: string;
    const fdv: FreedataValueVO = params.data; // ligne source
    const colDef: WizColDef = params.colDef; // définition de la colonne
    const code: string = params.colDef.field; // champ mesure cible code#mode|fonction d'aggrégat
    // identifiant unique de la colonne
    const colId: number = params.column.instanceId;
    // valeur calculée par keyValueAccessor
    const val: string = params.value;
    // le format
    const format: string = params.colDef.dataformat;

    // console.log('arg', params);
    const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, colDef.fdvfield);

    // patch gestion de l'extraction en mode brute
    if(format) {
      try {
        let formatKind: string = format.split(WizConstants.KEY_SEPARATOR)[1];
        if(formatKind === WizConstants.RAW) {
          result = params.value;
          // console.log('list format', format, result);
          return result;
        }
      } catch(e: any) {

      }    
    }


    result = this.model.listFieldEngine.generateThresholdRendererForFDV(this.fakeFei, fdv, arg, val);
    return result;
  }

 /**
   * mise à jour de la valeur d'une cellule en édition directe
   * possible saisie en masse. Le mode sera dans ce cas déterminé par mem (massEditMode)
   *
   * @param cell contient le node (la ligne), la WidgetLine porteuse, la colDef, la oldValue et la newValue
   */
  public updateCell(cell: any): boolean {
      
    // console.log('updateCell FDGRID', cell.newValue, cell.oldValue);
    if (cell.newValue !== cell.oldValue) {
      // la WidgetLine de base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
      const fdv: FreedataValueVO = cell.data;
      let field: string = cell.colDef.fdvfield?.split(WizConstants.FD_PARTS_SEPARATOR)[0];
      this.model.freedataEngine.feedFreedataValueField(fdv, field, cell.newValue);
      let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fdv.freeDataCode);
      freedata.resetUpdateMap(); // on vide l'historique sur le FD, au cas où...
      freedata.addToUpdatePack(fdv, EM_ACTION.UPDATE);
    
      const csp: CompositeSourcePack = {
        freedataManagement: true,
        freedata: freedata, // update / create / delete sur FDV
        // maj sur des Baselines / BLVs
      }

      // mémorisation de la demande dans la pile de modifs pour éventuel revert
      this.lastUpdatePile.push({fdv, argCode: field, value: cell.oldValue})
      if(this.lastUpdatePile.length > 10) {
        this.lastUpdatePile.splice(0,this.lastUpdatePile.length - 10); // pas plus de 10
      }

      this.model.compositeEngine.compositeCommit(csp, null, true);
    }
    return true;
  }

  /**
   * clic sur le crayon d'édition
   * @param params CellClickedEvent tout le bazard { colDef, data, column, event, value }
   * CellClickedEvent
   */
  onCellEdit(params: any) {
      
    if (!this.checkBeforeEdit(params, true)) { // seulement si autorisé
      return;
    }

    const wizColDef: WizColDef = params.colDef as any as WizColDef; // définition de la colonne
    const fdv: FreedataValueVO = params.data;

    let field: string = wizColDef.fdvfield?.split(WizConstants.FD_PARTS_SEPARATOR)[0];
    const arg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(fdv.freeDataCode, field);
    const datakind: string = arg.dataType;

    const widget: IWidget = (params.colDef as WizColDef).widget;
    const fkd: FeiKeyDef = wizColDef.fkd;

    // ### construction du label  
    let title: string = arg.trsLabel;

    let datas: PivotCellEditPopData = { 
      kind: WIDGET_GLOBAL_KIND.FREEDATA,
      title, 
      label: null, 
      value: params.value, // realValue, //
      column: params.column,
      fdv,
      arg,
      pointer: params.event as PointerEvent,
      widget, callback: this.backFromEditPop.bind(this)};

    /** ouverture de la pop d'édition en masse */
    // dispatch de l'event, sert possiblement pour sélection rapide sur le master, synchro des esclaves
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.SHOWPOP, datas));

  }

  /**
   * callBack de retour de la popUp d'édition en masse
   * @param data PivotCellEditPopData, avec UpdateRequest
   */
  public backFromEditPop(data: PivotCellEditPopData): void {
    // console.log('back from edit workflow', data);
    const fdv: FreedataValueVO = data.fdv;
    const arg: FreedataArgsVO = data.arg;

    let oldValue: any = this.model.freedataEngine.getFDValue(fdv, arg.code);
    this.model.freedataEngine.feedFreedataValueField(fdv, arg.code, data.updates?.value);
    
    let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fdv.freeDataCode);
    freedata.resetUpdateMap(); // on vide l'historique sur le FD, au cas où...
    freedata.addToUpdatePack(fdv, EM_ACTION.UPDATE);
    
    const csp: CompositeSourcePack = {
      freedataManagement: true,
      freedata: freedata, // update / create / delete sur FDV
    }

    // mémorisation de la demande dans la pile de modifs pour éventuel revert
    this.lastUpdatePile.push({fdv, argCode: arg.code, value: oldValue})
    if(this.lastUpdatePile.length > 10) {
      this.lastUpdatePile.splice(0,this.lastUpdatePile.length - 10); // pas plus de 10
    }

    this.model.compositeEngine.compositeCommit(csp, null, true);
  }

  /** mémorisation du focus */
  private onCellFocus(focusedCell: CellPosition): void {
    // console.log('onCellFocus', focusedCell?.column.getColDef());
    // prise de la valeur de la cellule cible
    let lastRow: number = this.widget.model.widgetEngine.lastFocusedCell?.focusedCell?.rowIndex;
    let lastCol: string = this.widget.model.widgetEngine.lastFocusedCell?.focusedCell?.column?.getId();
    // console.log('onCellFocus last', lastRow, lastCol);
    // console.log('onCellFocus new', focusedCell?.rowIndex, focusedCell?.column.getId());
    if(lastRow !== focusedCell?.rowIndex || lastCol !== focusedCell?.column?.getId()) {
      this.model.widgetEngine.lastFocusedCell = {pivotUID: this.uid, focusedCell, wl: null, pce: null };
    } else {
      // déjà alimenté par pivotCellEditor
    } 
  }

  /**
   * sur retour de commit, sync des lignes du FDGrid pour maj version
   * @param data: DataPack
   * @return true si delete ou create, on va rebuild les lignes dans ce cas
   */
  public syncDS(data: DataPack): boolean {
    // console.log('syncDS', data);
    let mustRefresh: boolean = false;

    if(data.deletedFreedataAndValues?.length > 0) {
      mustRefresh =  true;
    } else {
      data.inFreedataValues?.forEach(fdv => {
      let src: FreedataValueVO = this.fdvDS.getItemByKey(fdv.code);
      if(src) {
        src.source = fdv;
        // console.log('syncDS', src, this.fdvDS);
      } else { // pas trouvé, c'est un nouveau. On reconstruit les lignes    
        mustRefresh = true;
        return; // on sort de la boucle
      }
    });
    }
    
    return mustRefresh;
  }

  /**
   * piles des updates dans le pivot (max 10)
   */
  private lastUpdatePile: UpdateRevert[] = [];

  /** gestion du ctrl-Z pour inverser le dernier update */
  private trapCrtlZ(trap: CellKeyPressEvent | FullWidthCellKeyPressEvent): void {
    
      
    if(trap.event instanceof KeyboardEvent) {
      let kbe: KeyboardEvent = trap.event as KeyboardEvent;
      if(kbe.ctrlKey && kbe.charCode === 26) {
        // console.log('trapCrtlZ', trap.data);
              
        if(this.lastUpdatePile.length > 0) {
          let ue: UpdateRevert = this.lastUpdatePile.pop();
          if(ue) {
            this.crtrZRollback(ue);
          }
        }
      }
    }
  }

  private crtrZRollback(ur: UpdateRevert): void {
    
    // console.log('back crtrZRollback', ur);
    const fdv: FreedataValueVO = ur.fdv;
    this.model.freedataEngine.feedFreedataValueField(fdv, ur.argCode, ur.value);
    
    let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fdv.freeDataCode);
    freedata.resetUpdateMap(); // on vide l'historique sur le FD, au cas où...
    freedata.addToUpdatePack(fdv, EM_ACTION.UPDATE);
    
    const csp: CompositeSourcePack = {
      freedataManagement: true,
      freedata: freedata, // update / create / delete sur FDV
    }
    this.model.compositeEngine.compositeCommit(csp, null, false);
  }

  /**
   * Handler sur le clic d'une colonne de type boolean (checkbox)
   * @param params CellCheckedEvent { colDef, data, column, event, value }
   * @returns 
   */
  public onCellChecked(params: CellCheckedEvent): void {
    
    if (this._context.eda === false) { // widget en lecture seule
      return;
    }
    
    // forcer le passage en 2 états, le undefined est juste un état d'affichage en pivot
    if (params.newValue === WIZ_BOOLEAN.UNKNOWN) {
      params.newValue = WIZ_BOOLEAN.FALSE;
    }
    


    // la WidgetLine de base pour cette ligne. Ce n'est pas forcément la bonne ligne pour la colonne...
    const fdv: FreedataValueVO = params.data;
    let field: string = (params.colDef as WizColDef).fdvfield?.split(WizConstants.FD_PARTS_SEPARATOR)[0];
    
    let oldValue: any = this.model.freedataEngine.getFDValue(fdv, field);
    
    this.model.freedataEngine.feedFreedataValueField(fdv, field, params.newValue);
    let freedata: FreeDataVO = this.model.freedataEngine.getFreeData(fdv.freeDataCode);
    freedata.resetUpdateMap(); // on vide l'historique sur le FD, au cas où...
    freedata.addToUpdatePack(fdv, EM_ACTION.UPDATE);
  
    const csp: CompositeSourcePack = {
      freedataManagement: true,
      freedata: freedata, // update / create / delete sur FDV
      // maj sur des Baselines / BLVs
    }

    // mémorisation de la demande dans la pile de modifs pour éventuel revert
    this.lastUpdatePile.push({fdv, argCode: field, value: oldValue})
    if(this.lastUpdatePile.length > 10) {
      this.lastUpdatePile.splice(0,this.lastUpdatePile.length - 10); // pas plus de 10
    }

    this.model.compositeEngine.compositeCommit(csp, null, false);
  }


}
